<template>
    <div class="vue-product-carousel">
        <div class="row">
            <div class="col-12">
                <div class="product-thumbnail-wrapper" @click="lightboxIndex = currentIndex">
                    <img :src="thumbnail" class="img-fluid product-thumbnail">
                </div>
            </div>
        </div>

        <template v-if="hasSlides === true">
            <hooper ref="carousel" :settings="hooperSettings" @slide="handleSlide">
                <slide v-for="(image, index) in images" :key="index">
                    <a href="#" @click.prevent="handleSlideClick(index)">
                        <img :src="image">
                    </a>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
            </hooper>
        </template>

        <vue-gallery-slideshow :images="images" :index="lightboxIndex"
                               @close="lightboxIndex = null"></vue-gallery-slideshow>
    </div>
</template>

<script>
import {Hooper, Slide, Navigation as HooperNavigation} from 'hooper';
import 'hooper/dist/hooper.css';

import VueGallerySlideshow from 'vue-gallery-slideshow';

export default {
    name: "ProductCarousel",

    props: ['images'],

    components: {
        Hooper,
        Slide,
        HooperNavigation,
        VueGallerySlideshow
    },

    data() {
        return {
            thumbnail: null,

            hooperSettings: {
                itemsToShow: 3,
                wheelControl: false,
            },

            lightboxIndex: null,
            currentIndex: 0
        }
    },

    mounted() {
        this.thumbnail = this.images[0];
    },

    computed: {
        hasSlides() {
            return !_.isEmpty(this.images) && this.images.length >= 2;
        }
    },

    methods: {
        handleSlide(payload) {
            if (this.hasSlides === false) {
                return;
            }

            this.thumbnail = this.images[payload.currentSlide];
            this.currentIndex = payload.currentSlide;
        },

        handleSlideClick(index) {
            this.$refs.carousel.slideTo(index);
        }
    }
}
</script>
